import { numberSeparator } from './formats';

export const defaults = {
  currency: 'kr',
};

export const prettify = (
  value: number,
  currency = defaults.currency,
  decimals = 0,
  divider = ' ',
  decimalSeparator = '.',
) =>
  value ? `${numberSeparator(value, decimals, 3, divider, decimalSeparator)} ${currency}` : '-';
